/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { css } from '@emotion/react'
import { string, node } from 'prop-types'

import mediaQueries from '../../layout/media-queries'

const sidebarWrapperCss = ({ colors, spacing, font }) => css`
  display: none;
  position: fixed;
  top: 80px;
  bottom: 64px;
  width: 100%;
  min-width: 220px;
  left: 0;
  z-index: 1;
  background-color: ${colors.white};
  padding: ${spacing.s};
  padding-top: 0;
  overflow: auto;

  ${mediaQueries.mediumScreen()} {
    position: initial;
    display: block;
    width: 30%;
    min-width: 290px;
    padding-left: ${spacing.m};
    margin-right: 48px;
  }

  ${mediaQueries.largeScreen()} {
    padding-left: ${spacing.l};
    margin-right: 48px;
  }

  ${mediaQueries.xlargeScreen()} {
    padding-left: ${spacing.xl};
    margin-right: 48px;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  a {
    display: flex;
    align-items: center;
    margin-left: 5px;
    margin-bottom: 14px;
    color: ${colors.black};
    text-decoration: none;
    font-size: 16px;
    line-height: 28px;

    &:hover {
      color: ${colors.blue600};
    }

    > svg {
      flex-shrink: 0;
      margin-right: 10px;
      margin-top: -4px;
    }

    &.active-link {
      color: ${colors.blue500};
      font-weight: ${font.bold};

      > span > svg {
        color: ${colors.blue500};
      }

      > svg > path {
        fill: ${colors.blue500};
      }
    }
  }

  > h3 {
    margin: 0;
    margin-bottom: 24px;
    font-size: 18px;
    font-weight: ${font.bold};
    line-height: 28px;
  }
`

const SidebarWrapper = ({ className, children }) => (
  <aside css={sidebarWrapperCss} className={className}>
    {children}
  </aside>
)

SidebarWrapper.propTypes = {
  className: string,
  children: node,
}

export default SidebarWrapper
